import React, { useEffect, useRef, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";

const AdminDashboard = () => {
  const tabsRef = useRef(null);
  const [showScrollHint, setShowScrollHint] = useState(false);

  // Show the scroll chevron only while the tab strip can still scroll left (RTL).
  useEffect(() => {
    const el = tabsRef.current;
    if (!el) return;
    const update = () => {
      const max = el.scrollWidth - el.clientWidth;
      const atEnd = Math.abs(el.scrollLeft) >= max - 1;
      setShowScrollHint(max > 1 && !atEnd);
    };
    update();
    el.addEventListener("scroll", update, { passive: true });
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => {
      el.removeEventListener("scroll", update);
      ro.disconnect();
    };
  }, []);

  useEffect(() => {
    const wrap = document.querySelector(".header-wrapper");
    if (!wrap) return;

    const sync = () => {
      const bottom = Math.ceil(wrap.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty(
        "--shell-fixed-stack-bottom",
        `${bottom}px`,
      );
    };

    sync();
    const ro = new ResizeObserver(() => requestAnimationFrame(sync));
    ro.observe(wrap);
    return () => ro.disconnect();
  }, []);
  const sidebarAdmin = [
    { Title: "לקוחות", Link: "/admin/users", Img: "clients.svg" },
    { Title: "הזמנות", Link: "/admin/history", Img: "cart.svg" },
    { Title: "תשלומים", Link: "/admin/payments", Img: "cart.svg" },
    { Title: "פריטים", Link: "/admin/products", Img: "related-products.svg" },
    { Title: "מחלקות", Link: "/admin/category-edit", Img: "list.svg" },
    { Title: "מסננים", Link: "/admin/filters", Img: "filter.svg" },
    /*{
      Title: "יצירת מחסן",
      Link: "/admin/station",
      Img: "location.svg",
    },*/
    {
      Title: "מבצעים",
      Link: "/admin/sales-management",
      Img: "notifications.svg",
    },
    {
      Title: "השוואת מחירים",
      Link: "/admin/price-compare",
      Img: "bar_chart.svg",
    },
    { Title: "קופונים", Link: "/admin/coupons" },
    {
      Title: "הגדרות משלוח",
      Link: "/admin/delivery-edit",
      Img: "settings.svg",
    },
  ];

  return (
    <div className="admin-dashboard">
      <div
        className={`admin-dashboard__tabs${showScrollHint ? " has-scroll-hint" : ""}`}
        ref={tabsRef}
      >
        {sidebarAdmin.map((element, index) => (
          <NavLink to={element.Link} className="tab" key={index}>
            <span>{element.Title}</span>
          </NavLink>
        ))}
      </div>
      <div className="admin-dashboard__spacer" aria-hidden="true" />
      <div className="admin-dashboard__outlet">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminDashboard;
